
import { Prop } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';


@Options({})
export default class Modal extends Vue {
  isOpen = false;

  @Prop(Boolean)
  hasFooter = false;

  @Prop(String)
  title = '';

  open () {
    this.isOpen = true;
  }

  close () {
    this.isOpen = false;
  }
}
